<template>
  <div class="collapse-list">
    <div class="collapse-list__header">
      <div class="collapse-list__header__left">
        <Btn color="ghost" icon size="small" data-test-id="collapse-list-toggle" @click="$emit('toggle')">
          <ChevronDownIcon16 v-if="collapsed" />
          <ChevronUpIcon16 v-else />
        </Btn>
        <div class="collapse-list__title">
          {{ title }}&nbsp;
          <span class="collapse-list__title__count">
            {{ count }}
          </span>
        </div>
        <div v-if="hasSlotLeftaction" class="collapse-list__left-action">
          <slot name="leftaction" />
        </div>
      </div>
      <div class="collapse-list__right-action">
        <slot name="rightaction" />
      </div>
    </div>
    <div class="collapse-list__content" v-if="!collapsed">
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Btn from '@components/common/Btn.vue';
import ChevronDownIcon16 from '@components/Icons/ChevronDownIcon16.vue';
import ChevronUpIcon16 from '@components/Icons/ChevronUpIcon16.vue';
import { hasSlotContent } from '@components/slots';

export default defineComponent({
  name: 'CollapseList',

  components: {
    Btn,
    ChevronDownIcon16,
    ChevronUpIcon16,
  },

  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },

    count: {
      type: Number,
      default: null,
    },

    title: {
      type: String,
      default: '',
    },
  },

  emits: { toggle: null },

  computed: {
    hasSlotLeftaction() {
      return hasSlotContent(this.$slots.leftaction, {});
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';
.collapse-list {
  padding: 0;
}

.collapse-list__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.collapse-list__header__left {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 8px;
  align-items: center;
}

.collapse-list__title {
  color: colors.$color-grey-700;

  @include typography.typography-baseline-alignment;
  @include typography.typography-14-medium;
  @include typography.typography-ellipsis;

  &__count {
    color: colors.$color-grey-500;
  }
}

.collapse-list__content {
  padding-top: 16px;
}

.collapse-list__right-action {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  grid-gap: 8px;
}
</style>
